<script setup lang="ts">
import { provide, ref, type Ref } from 'vue'
import type { IncidentType } from '@/models/IncidentType'
import type { Room } from '@/models/Room'
import type { Container } from '@/models/Container'

const incidentType: Ref<IncidentType | null> = ref(null)
const incidentMessage: Ref<string | null> = ref(null)
const room: Ref<Room | null> = ref(null)
const container: Ref<Container | null> = ref(null)
const picture: Ref<string | null> = ref(null)

provide('incidentType', incidentType)
provide('incidentMessage', incidentMessage)
provide('room', room)
provide('container', container)
provide('picture', picture)
</script>

<template>
  <RouterView />
</template>
